<template lang='pug'>
tbody
  tr.table-row(@click="goTo(idx)" v-for='(info, idx) in infos' :key='idx' :class='foldClass(idx) + " " + inactiveClass(idx) + " " + isWeightGTHZero(idx)')
    td.tableTop10-numbering {{getIndex(idx+1)}}
    TitleColumn(:info='info' :type="type")
    Column(:text='info.category[$store.state.lang].toString()' type='category')
    Column(v-if="type!='latestArticlesByPartner'" :text='info.url' type='url')
    Column(v-if="type!='latestArticlesByPartner'" :text='getNumberString(info.reporterCount)')
    FollowBar(v-if="type!='latestArticlesByPartner'" :follower='getNumberString(info.followerCount)' :bar='calReporterCount(info.followerCount)' type='followerCount')
    Column(v-if="type=='latestArticlesByPartner'" :text='info.updatedAtStr' type='updatedAt')
</template>
<script>
import Column from '@/components/modules/table_list/table_body_column.vue'
import TitleColumn from '@/components/modules/table_list/table_body_title_column.vue'
import FollowBar from '@/components/modules/table_list/table_body_follow_bar.vue'
import { getNumberString } from '@/plugins/tool.js'

export default {
  components: {
    Column,
    TitleColumn,
    FollowBar
  },
  props: {
    infos: Array,
    barBase: Number,
    unfolded: Boolean,
    type: String,
  },
  data() {
    return {
      getNumberString: getNumberString
    }
  },
  computed: {
    isMain() {
      return this.$route.path === '/'
    },
    isFollowing() {
      return this.$route.path === '/category' && this.$route.query.type === 'followingArticles'
    }
  },
  methods: {
    calReporterCount(reporterCount) {
      let _reporterCount = reporterCount
      if(reporterCount < this.barBase/5)
        return Math.floor( _reporterCount*15/this.barBase )
      else
        return Math.floor( _reporterCount*8/this.barBase )
    },
    foldClass(idx) {
      return (idx >= 5 && !this.unfolded && this.isMain) ? "show--bigScreens" : ""
    },
    inactiveClass(idx) {
      return this.isActive(idx) ? '' : 'table-row--inactive'
    },
    isWeightGTHZero(idx) {
      return this.infos[idx].weight > 0 ? 'tableTop10-row--active' : ''
    },
    isActive(idx) {
      if (!this.isFollowing) return true
      return this.infos[idx].tag.id !== 1
    },
    getIndex(idx) {
      if (idx < 10) {
        return '0' + idx.toString()
      }
      return idx.toString()
    },
    goTo(idx) {
      if (!this.isActive(idx)) return
      this.$router.push({
        "path": "/news",
        "query": {
          "categoryId": this.infos[idx].category.id,
          "articleId": this.infos[idx].id
        }
      })
    }
  }
}
</script>
<style scoped src='./table_body.vue.css'></style>
